import { Card } from "@/components/ui/card";
import { Callout } from "./callout";

export const VerificationCard = () => {
  return (
    <Card className="px-6">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <div className="relative max-w-lg">
          <Callout>Process</Callout>
          <p className="my-4 text-2xl">Identity Verification</p>
          <div className="space-y-6 max-sm:text-lg/8">
            <p>
              Flash’s system validates the uploaded documents using a combination of fraud detection
              technology and human expertise. Once verified, the user’s profile is updated to show
              their “verified” status.
            </p>
            <p>
              Youth Verification: Users upload one of the following: birth certificate, passport,
              government-issued ID, or Native Tribal ID.
            </p>
            <p>
              Adult Verification: Users submit a driver’s license, government-issued ID, or
              passport.
            </p>
          </div>
        </div>
        <div className="not-sr-only relative -m-6 max-md:hidden">
          <img alt="Flash Document" src="/static/flash-card-cropped.png" />
        </div>
      </div>
    </Card>
  );
};
